<template>
  <div
    v-if="isAuthorized"
    class="personal-header__item"
  >
    <a class="personal-header__link" :href="link">
      {{ title }}
    </a>
  </div>
</template>

<script>
import PersonalRecommendationMixin from '@/js/vue/PersonalRecommendation/mixins/PersonalRecommendationMixin';

export default {
  name: 'PersonalRecommendationHeaderItem',
  mixins: [PersonalRecommendationMixin],
};
</script>
